import { Box } from "@cloudscape-design/components";
import { PlaceReportWithContacts, Task } from "../common/types";
import { PlaceContactsList } from "./PlaceContactsList";
import { useMemo } from "react";
import { PlaceStatus } from "./PlaceStatus";

export type PlaceReportPlaceContactsListProps = {
  item: PlaceReportWithContacts;
  showLineTypeInfo?: boolean;
};

export function PlaceReportPlaceContactsList(props: PlaceReportPlaceContactsListProps) {
  const { item } = props;

  const tasks = item.tasks ?? [];

  
  const sortedTasks = useMemo(() => {
    const sortedTasks = [...tasks];
    sortedTasks.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    return sortedTasks;
  }, [tasks]);

  const mostRecentTask = sortedTasks[0];

  const task =
    sortedTasks.length > 0
      ? mostRecentTask
      : ({
          uuid: '',
          status: 'pending',
          name: 'collect_details',
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          environment: null,
          retries: null,
        } as Task);

  const status = task.status;
  const name = task.name;
  return (
    item.place?.contacts && item.place?.contacts.length > 0 ? (
      <PlaceContactsList contacts={item.place.contacts} showLineTypeInfo={props.showLineTypeInfo} />
    ) : (
      status !== 'completed' ? (
        <PlaceStatus tasks={item.tasks} />
      ) : (
        <Box variant="span">-</Box>
      )
    )
  )
}
